/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fade } from "react-awesome-reveal";
import TypedTitle from "./TypedTitle";
import { Link } from "react-scroll";
import { FaHeadset } from "react-icons/fa";

export default function Text() {
  return (
    <Fade cascade damping={0.2}>
      <h1 className="text-5xl font-extrabold text-[#002057] max-md:text-4xl">
        Hi There, <br />
        I'm Ali <span className="text-[#ff7b00]">El-Shoraa</span>
      </h1>

      {/* *********************************************************************************************************** */}

      <h3 className="text-2xl max-md:text-xl">
        I Am Into <br className="md:hidden" />
        <span className="text-[#940808] font-semibold">
          <TypedTitle />
        </span>
      </h3>

      {/* *********************************************************************************************************** */}

      <Link
        smooth
        to="contact"
        className="sp-button-components !flex items-center gap-2"
      >
        <FaHeadset />
        Contact Me
      </Link>
    </Fade>
  );
}
